import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _omit from 'lodash/omit';
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveIframe } from '@zillow/zrs-cms';
import { usePlacement } from '../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["width", "height", "allowFullScreen", "loading"];
var BlockEmbed = function BlockEmbed(_ref) {
  var attrs = _ref.attrs;
  var isPost = usePlacement() === 'post';
  var _attrs$width = attrs.width,
    width = _attrs$width === void 0 ? 1024 : _attrs$width,
    _attrs$height = attrs.height,
    height = _attrs$height === void 0 ? 768 : _attrs$height,
    _attrs$allowFullScree = attrs.allowFullScreen,
    allowFullScreen = _attrs$allowFullScree === void 0 ? true : _attrs$allowFullScree,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    iframeAttributes = _objectWithoutProperties(attrs, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line zillow/jsx-a11y/iframe-has-title
    React.createElement(ResponsiveIframe, _extends({}, _omit(iframeAttributes, 'margin'), {
      allowFullScreen: allowFullScreen,
      loading: loading,
      width: width,
      height: height
    }, isPost ? {
      marginBottom: 'md'
    } : iframeAttributes.margin))
  );
};
BlockEmbed.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    allowFullScreen: PropTypes.bool,
    title: PropTypes.string,
    loading: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Embed = BlockEmbed;

export { Embed as default };
